// Bank accounts available for the school. Stored as the literal string that
// will land in the welcome email "Depósito bancario / Bank deposit" block.
// If the school needs to add more accounts later, append entries here.
export const BANK_ACCOUNTS = [
  { value: "BAC San José — IBAN CR61010200009721194409", label: "BAC — Presencial (CR61…194409)" },
  { value: "BAC San José — IBAN CR48010200007035939472", label: "BAC — Online (CR48…939472)" },
];
